// eslint-disable-next-line no-unused-vars
import { Address, Location } from '@/generated-clients/myTrips'

// eslint-disable-next-line no-unused-vars
import { ContextItem } from '@clients/mapbox'

export function featureToAddress (result: any): Address {
  const locality = extractTextFromMapboxContext(result.context, 'place')
  let stateRegion = extractTextFromMapboxContext(result.context, 'region')

  if (!stateRegion) { // sometimes mapbox doesn't return a region (Bundesland), especially for Vienna and other capitols
    stateRegion = locality
  }

  return {
    locality,
    stateRegion,
    moniker: result.place_name_de,
    streetLine: result.place_name_de.split(',')[0],
    areaCode: extractTextFromMapboxContext(result.context, 'postcode'),
    country: extractTextFromMapboxContext(result.context, 'country'),
  }
}

export function featureToLocation (result: any): Location {
  return {
    longitude: result.center[0],
    latitude: result.center[1],
  }
}

function extractTextFromMapboxContext (context, id) {
  const item = context.find((item: ContextItem) => item.id.indexOf(id) !== -1)
  return (item) ? item.text_de : null
}
